import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import Config from "src/Constants/Config";

const PageId = 0;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (currentPage === PageId) videoRef.current.play();
      else {
        videoRef.current.pause();
        setTimeout(() => {
          if (videoRef.current) videoRef.current.currentTime = 0;
        }, 300);
      }
    }
  }, [currentPage]);

  const handleOnClick = () => setCurrentPage(NextPageId);

  return {
    title: "Intro Video",
    showHeader: false,
    fullScreen: true,
    children: (
      <video
        onClick={handleOnClick}
        ref={videoRef}
        id="videoEntertainment"
        preload="metadata"
        controls={false}
        loop
        style={{ width: "100%" }}
      >
        <source src={`${Config.BASE_URL}/videos/240704_Infosys_Connectivity_h264_30MBit.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    ),
  };
};

export default DATA;
